import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Field, FormSpy } from 'react-final-form';
import { showAppNotification, hideAppSpinner, showAppSpinner } from '@rainbow-modules/app';
import useHttpMutation from 'data/firestore/useHttpMutation';
import Button from 'components/Button';
import {
    Section,
    SectionContent,
    FormFooter,
} from '../styled';
import { StyledUniversalForm, StyledInput } from './styled';

const ApiKeysSection = () => {
    const { agentId = '' } = useParams();
    const [valid, setValid] = useState(false);

    const { mutateAsync: createOrUpdateSecretKey } = useHttpMutation({
        method: 'POST',
        pathname: `/agents/${agentId}/secrets`,
    });

    const handleSubmit = useCallback(
        async (values: { MANYCHAT_API_KEY?: string }) => {
            showAppSpinner();
            const { MANYCHAT_API_KEY = '' } = values;
            if (!MANYCHAT_API_KEY?.trim()) return;
            try {
                await createOrUpdateSecretKey({
                    body: {
                        name: 'MANYCHAT_API_KEY',
                        value: MANYCHAT_API_KEY.trim(),
                    },
                });
                showAppNotification({
                    title: 'Success',
                    description: 'ManyChat API Key was successfully saved',
                    icon: 'success',
                    timeout: 5000,
                });
            } catch (error) {
                showAppNotification({
                    title: 'Error',
                    description: 'Something went wrong. Please try again.',
                    icon: 'error',
                    timeout: 5000,
                });
            }
            hideAppSpinner();
        },
        [createOrUpdateSecretKey],
    );

    return (
        <Section>
            <SectionContent>
                <StyledUniversalForm
                    id="api-keys-form"
                    onSubmit={handleSubmit}
                >
                    <Field
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        component={StyledInput}
                        name="MANYCHAT_API_KEY"
                        label="ManyChat API Key"
                        type="password"
                        placeholder="************"
                        labelAlignment="left"
                        borderRadius="semi-rounded"
                        autoComplete="off"
                    />
                    <FormSpy
                        subscription={{ values: true }}
                        onChange={({ values }) => setValid(
                            Boolean(values.MANYCHAT_API_KEY?.trim()),
                        )}
                    />
                </StyledUniversalForm>
            </SectionContent>
            <FormFooter>
                <Button
                    label="Save"
                    variant="brand"
                    borderRadius="semi-rounded"
                    form="api-keys-form"
                    type="submit"
                    disabled={!valid}
                />
            </FormFooter>
        </Section>
    );
};

export default ApiKeysSection;
